import { Navigate } from 'react-router-dom';
import { useAuthOptionsQuery } from '@platform/features/auth';
import { authRoutes } from '../auth/authRoutes';
import { LoginPage } from '../auth/LoginPage';
import { ObserverPicker } from './ObserverPicker';

/** /observe (і #observe на будь-якій адресі застосунку): вибір особи поверх екрана входу; вимкнений режим спостерігача (observer.enabled) — вхід. */
export function ObserverPage() {
  const { data: options } = useAuthOptionsQuery();
  if (options && !options.observer) return <Navigate to={authRoutes.login()} replace />;
  return (
    <>
      <LoginPage />
      {options && <ObserverPicker />}
    </>
  );
}
